import { Injectable } from '@angular/core';
import { AngularFirestore } from "@angular/fire/compat/firestore";
import firebase from "firebase/compat/app";
import { Observable } from "rxjs";
import { ManagementMOM } from "./counsellors-mom.model";

/**
 * Service for managing Management MOM (Minutes of Meeting) sessions
 */
@Injectable({
  providedIn: 'root'
})
export class ManagementMomService {
  private collection = this.firestore.collection<ManagementMOM>('Counselling/MOM/management-mom-sessions');

  constructor(private firestore: AngularFirestore) {}

  /**
   * Create a new management MOM session
   * @param data The management MOM session data
   */
  create(data: ManagementMOM): Promise<any> {
    const payload: ManagementMOM = {
      ...data,
      createdAt: firebase.firestore.FieldValue.serverTimestamp() as any,
      updatedAt: firebase.firestore.FieldValue.serverTimestamp() as any,
    };
    return this.collection.add(payload);
  }

  /**
   * Get a management MOM session by ID
   * @param id The session ID
   */
  getDataById(id: string): Observable<ManagementMOM | undefined> {
    return this.collection.doc<ManagementMOM>(id).valueChanges({ idField: 'id' });
  }

  /**
   * Get all management MOM sessions
   */
  getAll(): Observable<ManagementMOM[]> {
    return this.collection.valueChanges({ idField: 'id' });
  }

  /**
   * Update a management MOM session
   * @param id The session ID
   * @param data The updated data
   */
  update(id: string, data: Partial<ManagementMOM>): Promise<void> {
    const payload = {
      ...data,
      updatedAt: firebase.firestore.FieldValue.serverTimestamp()
    };
    return this.collection.doc(id).update(payload);
  }

  /**
   * Delete a management MOM session
   * @param id The session ID
   */
  deleteRow(id: string): Promise<void> {
    return this.collection.doc(id).delete();
  }
}

